import React from 'react';
import { Navigate } from 'react-router-dom';

const NonAuthRoute = ({ children }) => {
    const token = localStorage.getItem('tokenData');

    return ((token == null || token == "") ? children : <Navigate to="/dashboard" />);
};

export default NonAuthRoute;